document.addEventListener('DOMContentLoaded', function() {
  // Global variable to track if we're already observing
  let isObserving = false;
  
  // Tab functionality for search results
  const tabs = document.querySelectorAll('.search-tab');
  const contents = document.querySelectorAll('.search-tab-content');

  tabs.forEach(tab => {
    tab.addEventListener('click', function(e) {
      e.preventDefault();
      
      const targetTab = this.getAttribute('data-tab');
      
      // Remove active class from all tabs and contents
      tabs.forEach(t => t.classList.remove('active'));
      contents.forEach(c => c.classList.remove('active'));
      
      // Add active class to clicked tab
      this.classList.add('active');
      
      // Show corresponding content
      const targetContent = document.getElementById(targetTab + '-content');
      if (targetContent) {
        targetContent.classList.add('active');
      }
      
      // Show/hide facets based on tab selection
      const facetsWrapper = document.querySelector('.facets-wrapper');
      const facetsForm = document.querySelector('.facets-vertical-sort');
      const activeFilters = document.querySelector('.active-filters-above-grid');
      
      if (targetTab === 'products') {
        if (facetsWrapper) facetsWrapper.style.display = 'block';
        if (facetsForm) facetsForm.style.display = 'block';
        if (activeFilters) activeFilters.style.display = 'block';
      } else {
        if (facetsWrapper) facetsWrapper.style.display = 'none';
        if (facetsForm) facetsForm.style.display = 'none';
        if (activeFilters) activeFilters.style.display = 'none';
      }
    });
  });

  // Desktop Sort Dropdown Functionality - Updated for static HTML
  function initDesktopSortDropdown() {
    const sortSelect = document.querySelector('#SortBy');
    const selectContainer = sortSelect?.closest('.select');
    const customDropdown = document.querySelector('.custom-sort-dropdown');
    const optionsContainer = document.querySelector('.custom-sort-options');
    
    if (!sortSelect || !selectContainer || !customDropdown || !optionsContainer) {
      return;
    }
    
    // Check if already initialized
    if (customDropdown._sortInitialized) {
      return;
    }
    
    customDropdown._sortInitialized = true;
    
    // Update current text based on selected option
    const currentText = customDropdown.querySelector('.custom-sort-current');
    const selectedOption = sortSelect.options[sortSelect.selectedIndex];
    // if (currentText && selectedOption) {
    //   currentText.textContent = selectedOption.textContent;
    // }
    
    // Update selected state in options
    optionsContainer.querySelectorAll('.custom-sort-option').forEach(option => {
      option.classList.remove('selected');
      if (option.dataset.value === sortSelect.value) {
        option.classList.add('selected');
      }
    });
    
    // Handle dropdown toggle
    customDropdown.addEventListener('click', function(e) {
      e.preventDefault();
      e.stopPropagation();
      
      const isOpen = customDropdown.classList.contains('open');
      
      // Close all other dropdowns
      document.querySelectorAll('.custom-sort-dropdown.open').forEach(dropdown => {
        if (dropdown !== customDropdown) {
          dropdown.classList.remove('open');
        }
      });
      
      // Toggle current dropdown
      customDropdown.classList.toggle('open', !isOpen);
    });
    
    // Handle option selection
    optionsContainer.addEventListener('click', function(e) {
      e.preventDefault();
      e.stopPropagation();
      
      if (e.target.classList.contains('custom-sort-option')) {
        const selectedValue = e.target.dataset.value;
        
        // Update visual state
        optionsContainer.querySelectorAll('.custom-sort-option').forEach(opt => {
          opt.classList.remove('selected');
        });
        e.target.classList.add('selected');
        
        // Update current text
        // if (currentText) {
        //   currentText.textContent = e.target.textContent;
        // }
        
        customDropdown.classList.remove('open');
        
        // Update hidden select
        sortSelect.value = selectedValue;
        
        // Get current URL and update sort parameter
        const url = new URL(window.location);
        url.searchParams.set('sort_by', selectedValue);
        
        // Perform AJAX update
        performSortUpdate(url.toString());
      }
    });
    
    // Close dropdown when clicking outside
    const closeHandler = function(e) {
      if (!selectContainer.contains(e.target)) {
        customDropdown.classList.remove('open');
      }
    };
    
    document.addEventListener('click', closeHandler);
    
    // Store the close handler so we can remove it later if needed
    selectContainer._closeHandler = closeHandler;
  }
  
  // AJAX sort update function (used by both desktop and mobile)
  function performSortUpdate(sortUrl) {
    // Show loading state
    const productGrid = document.getElementById('ProductGridContainer') || document.getElementById('product-grid');
    if (productGrid) {
      productGrid.classList.add('loading');
      
      const loadingOverlay = productGrid.querySelector('.loading-overlay');
      if (loadingOverlay) {
        loadingOverlay.style.display = 'block';
      }
    }
    
    // Perform the AJAX request
    fetch(sortUrl, {
      method: 'GET',
      headers: {
        'X-Requested-With': 'XMLHttpRequest',
        'Accept': 'text/html'
      }
    })
    .then(response => response.text())
    .then(html => {
      // Parse the response
      const parser = new DOMParser();
      const newDoc = parser.parseFromString(html, 'text/html');
      
      // Update the product grid
      const newProductGrid = newDoc.getElementById('ProductGridContainer') || newDoc.getElementById('product-grid');
      if (newProductGrid && productGrid) {
        productGrid.innerHTML = newProductGrid.innerHTML;
      }
      
      // Update the URL without refresh
      window.history.pushState({}, '', sortUrl);
      
      // Update any product count displays
      const productCount = document.getElementById('ProductCountDesktop');
      const newProductCount = newDoc.getElementById('ProductCountDesktop');
      if (productCount && newProductCount) {
        productCount.innerHTML = newProductCount.innerHTML;
      }
      
      // Remove loading state
      if (productGrid) {
        productGrid.classList.remove('loading');
        const loadingOverlay = productGrid.querySelector('.loading-overlay');
        if (loadingOverlay) {
          loadingOverlay.style.display = 'none';
        }
      }
      
      // Re-initialize both desktop dropdown and mobile modal after AJAX update
      setTimeout(() => {
        initDesktopSortDropdown();
        initMobileSortModal();
      }, 100);
    })
    .catch(error => {
      console.error('Sort update failed:', error);
      // Remove loading state on error
      if (productGrid) {
        productGrid.classList.remove('loading');
        const loadingOverlay = productGrid.querySelector('.loading-overlay');
        if (loadingOverlay) {
          loadingOverlay.style.display = 'none';
        }
      }
      // Fallback to page refresh
      window.location.href = sortUrl;
    });
  }

  // DOM observer for desktop dropdown re-initialization
  function observeForDesktopDropdown() {
    if (isObserving) return;
    
    const targetNode = document.body;
    const config = { childList: true, subtree: true };
    
    const callback = function(mutationsList) {
      for (let mutation of mutationsList) {
        if (mutation.type === 'childList') {
          // Check if a sort select was added/updated
          const sortSelect = document.querySelector('#SortBy');
          const customDropdown = document.querySelector('.custom-sort-dropdown');
          if (sortSelect && customDropdown && !customDropdown._sortInitialized) {
            setTimeout(() => {
              initDesktopSortDropdown();
            }, 100);
          }
          
          // Check if mobile sort button was added/updated
          const mobileSortButton = document.querySelector('#mobileSortButton');
          if (mobileSortButton && !mobileSortButton._sortInitialized) {
            setTimeout(() => {
              initMobileSortModal();
            }, 100);
          }
        }
      }
    };
    
    const observer = new MutationObserver(callback);
    observer.observe(targetNode, config);
    isObserving = true;
  }

  // Mobile Sort Modal Functionality - Simplified
  let activeMobileSortOverlay = null;

  function initMobileSortModal() {
    const mobileSortButton = document.querySelector('#mobileSortButton');
    if (!mobileSortButton || mobileSortButton._sortInitialized) return;
    
    mobileSortButton._sortInitialized = true;
    mobileSortButton.addEventListener('click', openMobileSortModal);
  }

  function openMobileSortModal() {
    const originalOverlay = document.querySelector('#mobileSortOverlay');
    if (!originalOverlay || (activeMobileSortOverlay && document.body.contains(activeMobileSortOverlay))) return;
    
    // Create copy and append to body
    activeMobileSortOverlay = document.createElement('div');
    activeMobileSortOverlay.id = 'mobileSortOverlay';
    activeMobileSortOverlay.className = originalOverlay.className;
    activeMobileSortOverlay.innerHTML = originalOverlay.innerHTML;
    document.body.appendChild(activeMobileSortOverlay);
    
    // Add active classes
    document.body.classList.add('mobile-sort-modal-open');
    activeMobileSortOverlay.classList.add('active');
    const modal = activeMobileSortOverlay.querySelector('#mobileSortModal');
    if (modal) modal.classList.add('active');
    
    // Attach events
    attachMobileSortEvents();
  }

  function closeMobileSortModal() {
    if (!activeMobileSortOverlay) return;
    
    document.body.classList.remove('mobile-sort-modal-open');
    activeMobileSortOverlay.classList.remove('active');
    const modal = activeMobileSortOverlay.querySelector('#mobileSortModal');
    if (modal) modal.classList.remove('active');
    
    setTimeout(() => {
      if (activeMobileSortOverlay && activeMobileSortOverlay.parentNode) {
        activeMobileSortOverlay.parentNode.removeChild(activeMobileSortOverlay);
        activeMobileSortOverlay = null;
      }
    }, 300);
  }

  function attachMobileSortEvents() {
    if (!activeMobileSortOverlay) return;
    
    // Close events
    const closeBtn = activeMobileSortOverlay.querySelector('#closeMobileSortModal');
    if (closeBtn) closeBtn.addEventListener('click', closeMobileSortModal);
    
    activeMobileSortOverlay.addEventListener('click', (e) => {
      if (e.target === activeMobileSortOverlay) closeMobileSortModal();
    });
    
    // Escape key
    const escHandler = (e) => {
      if (e.key === 'Escape' && activeMobileSortOverlay?.classList.contains('active')) {
        closeMobileSortModal();
      }
    };
    document.addEventListener('keydown', escHandler);
    
    // Sort options
    activeMobileSortOverlay.querySelectorAll('.mobile-sort-option').forEach(option => {
      const radio = option.querySelector('input[type="radio"]');
      
      const handleSelection = () => {
        const sortUrl = option.getAttribute('data-sort-url');
        if (radio) radio.checked = true;
        
        // Update visual state
        activeMobileSortOverlay.querySelectorAll('.mobile-sort-option').forEach(opt => opt.classList.remove('selected'));
        option.classList.add('selected');
        
        setTimeout(() => {
          closeMobileSortModal();
          if (sortUrl) performSortUpdate(sortUrl);
        }, 300);
      };
      
      option.addEventListener('click', (e) => {
        if (e.target.type !== 'radio') handleSelection();
      });
      
      if (radio) radio.addEventListener('change', handleSelection);
    });
  }

  // Initialize everything
  function initAll() {
    initDesktopSortDropdown();
    initMobileSortModal();
    observeForDesktopDropdown();
  }
  
  // Start initialization immediately since HTML is now static
  initAll();
});